export class Unauthorized extends Error {}
